<template>
  <div>
    <ArticleList
      v-if="isListPage"
      :categoryId="pid"
      :pageTitle="pname"
      layout="list"
      detailPath="/join/joindetail"
      :sidebar="subCates"
      :showAll="false"
    />
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Join',
  data() {
    return {
      pid: 0,
      pname: '',
      subCates: []
    }
  },
  computed: {
    isListPage() {
      return this.$route.path === '/join'
    }
  },
  watch: {
    $route: {
      handler(newval) {
        if (newval.path === '/join') {
          // 用 Number() 归一化：URL 里的 pid 是字符串，字符串 "0" 是真值，
          // 会让下面的 if (!this.pid) 判断失效，兜底逻辑永远进不去
          this.pid = Number(newval.query.pid) || 0
          this.pname = newval.query.pname
          this.loadSubCates()
          if (!this.pid) this.fetchDefaultPid()
        }
      },
      deep: true
    }
  },
  created() {
    this.pname = this.$route.query.pname
    // 同上：字符串 "0" 会被当成有效分类，这里统一转成数字 0 触发兜底
    this.pid = Number(this.$route.query.pid) || 0
    this.loadSubCates()
    if (!this.pid) this.fetchDefaultPid()
  },
  methods: {
    // 拉取当前顶级分类下的子分类（只取 is_menu=1 的菜单项），供左侧导航
    loadSubCates() {
      this.$api.home.getnavList({ lang: 'zn' }).then(res => {
        let cat = res && res.data && res.data.category
        if (!Array.isArray(cat)) {
          cat = Array.isArray(res.data) ? res.data : Object.values((res && res.data) || {})
        }
        if (!Array.isArray(cat) || !this.pid) return
        this.subCates = cat
          .filter(c => Number(c.pid) === Number(this.pid) && Number(c.is_menu) === 1)
          .map(c => ({ id: c.id, name: c.name }))
      }).catch(() => {})
    },
    // URL 没传 pid 时，按顶级分类兜底找 pid
    // 注意：后端「加入我们」的 type 仍是 imglist（并非 join），所以按名称匹配更可靠
    async fetchDefaultPid() {
      try {
        const res = await this.$api.home.getnavList({ lang: 'zn' })
        let cat = res && res.data && res.data.category
        if (!Array.isArray(cat)) {
          cat = Array.isArray(res.data) ? res.data : Object.values(res.data || {})
        }
        const top = cat.find(c => Number(c.pid) === 0 &&
          (c.type === 'join' || (c.name && c.name.indexOf('加入我们') > -1)))
        if (top) {
          this.pid = top.id
          this.pname = this.pname || top.name
          this.loadSubCates()
        }
      } catch (e) { /* 接口失败就维持原样 */ }
    }
  }
}
</script>
